import React from "react";
import { transferFormType } from "../../../home/types";
import { Text } from "../../design-system/Text";
import TransferDetails from "../../../home/components/TransferDetails";
import { Img } from "../../design-system/Img";
import { useTheme } from "../../../../theme/ThemeProvider";

interface propType {
  showModal: boolean;
  toggleResultModal: () => void;
  status: transferFormType["approvalStatus"];
  transactionId?: string;
  transferData: any;
}

const ResultModal: React.FC<propType> = ({
  showModal,
  toggleResultModal,
  status,
  transactionId,
  transferData,
}) => {
  const { theme } = useTheme();

  if (!showModal) return null;

  return (
    <>
      <div
        className="justify-center items-center flex overflow-x-hidden 
      fixed inset-0 z-50 outline-none focus:outline-none"
      >
        <div className="relative w-auto my-6 mx-auto ">
          {/*content*/}
          <div
            className="border-0 rounded-[24px] shadow-lg relative flex flex-col w-[944px] h-[789px]
              bg-white-A700 outline-none 
             items-center focus:outline-none overflow-hidden"
          >
            <div className=" bg-custom-result-bg flex flex-1 flex-col w-full justify-center gap-10">
              <div className="w-full flex justify-center ">
                {status === "DECLINED" || status === "TIMEDOUT" ? (
                  <Img src="failed.svg" className="!w-[120px] !h-[120px]" />
                ) : (
                  <Img src={`${theme}-success.gif`} className={theme === "aub"?`!w-44 !h-42`:`!w-54 !h-52`} />
                )}
              </div>

              <div className="flex flex-col">
                <Text className="text-xl font-medium leading-6 text-center">
                  {status === "DECLINED"
                    ? "Transaction Declined"
                    : status === "TIMEDOUT"
                    ? "Transaction Timed Out"
                    : "Transaction successful"}
                </Text>
                {transferData.errorCode === "ERR_902" && (
                  <Text className="mt-5">
                    You have reached the Attempt limit
                  </Text>
                )}

                <div className="flex justify-center items-center mt-6">
                  <div className="flex flex-row items-center">
                    <Text className="text-sm font-normal leading-5 text-center">
                      Transactions ID:{" "}
                    </Text>
                    <Text className="text-sm font-medium leading-5 text-center">
                      {transactionId ?? "TSDB6478171"}
                    </Text>
                  </div>
                </div>
              </div>
              <TransferDetails
                transferData={transferData}
                toggleResultModal={toggleResultModal}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="opacity-25 fixed inset-0 z-40 bg-black-800 "
        onClick={toggleResultModal}
      />
    </>
  );
};

export default ResultModal;
